<template>
  <tw-badge v-if="minimal && BatchJob" variant="warning">
    {{ BatchJob.processedJobs }} / {{ BatchJob.totalJobs }}
  </tw-badge>
  <tw-card v-else class="bg-green-50">
    <div v-if="BatchJob" class="text-center">
      <tw-loading-spinner-mini v-if="batchState === 'in progress'" />
      Batch: <strong>{{ BatchJob.name? BatchJob.name : BatchJob.id }} </strong> is {{ batchState }}.
      <div v-if="BatchJob.totalJobs > 1">
        <strong>{{ BatchJob.processedJobs }} / {{ BatchJob.totalJobs }} </strong> processed.
      </div>
    </div>
    <div v-if="BatchJob" class="grid grid-cols-3 gap-2">
      <div :class="[{'col-span-2':batchState === 'in progress'}, {'col-span-3': batchState !== 'in progress'}, 'pt-2']">
        <tw-progress-bar :progress="(BatchJob.processedJobs / BatchJob.totalJobs) * 100" />
      </div>
      <div v-if="batchState === 'in progress'" class="col-span-1">
        <tw-button :loading="LoadingCancelling" class="mt-1" variant="danger" size="sm" @click="cancel">
          <span v-if="Loading">
            Cancelling...
          </span>
          <span v-else> Cancel </span>
        </tw-button>
      </div>
    </div>
  </tw-card>
</template>

<script>

import axios from 'axios'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwLoadingSpinnerMini from '@/components/generic/tw-loading-spinner-mini.vue'
export default {
  name: 'BatchMonitor',
  components: { TwLoadingSpinnerMini, TwLoadingSpinner, TwButton, TwProgressBar, TwCard, TwBadge },
  props: {
    modelValue: {
      type: [Object, String],
      required: true
    },
    minimal: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input','finished',''],
  data () {
    return {
      BatchJob: null,
      Loading: false,
      LoadingCancelling: false
    }
  },
  computed: {
    api() {
      return '/api/v1/batch';
    },
    isInProgress () {
      if (!this.modelValue) return false
      if (this.BatchJob) {
        return !this.BatchJob.cancelledAt && !this.BatchJob.finishedAt
      }
      return false
    },
    batchState () {
      if (!this.BatchJob) return 'not started'
      if (this.isInProgress) return 'in progress'
      if (this.BatchJob && this.BatchJob.cancelledAt) return 'cancelled'
      return 'finished'
    },
    percentage () {
      if (this.BatchJob) {
        return Math.round((this.BatchJob.processedJobs / this.BatchJob.totalJobs) * 100) + '%'
      }
      return 0
    }
  },
  async mounted () {
    // check if the modelValue prop is an object or a string
    if (typeof this.modelValue === 'object') {
      this.BatchJob = this.modelValue
    } else {
      // we received a string, fetch the batch job
      const { data } = await axios.get(`${this.api}/${this.modelValue}`)
      this.BatchJob = data
    }
    await this.checkStatus()
  },
  methods: {
    async monitor () {
      console.log(this.BatchJob, this.modelValue)
      const { data } = await axios.get(`${this.api}/${this.BatchJob.id}`)
      if (!data) {
        this.$emit('finished')
        this.$emit('input', null)
        return
      }

      if (this.isInProgress === true) {
        this.$emit('input', data)
        await this.checkStatus()
      } else {
        this.$emit('finished', this.BatchJob)
      }
      this.BatchJob = data
    },
    async checkStatus () {
      setTimeout(async (_) => {
        await this.monitor()
      }, 2000)
    },
    async cancel () {
      if (confirm('Are you sure you want to cancel this batch?') && this.BatchJob.id) {
        try {
          this.LoadingCancelling = true
          await axios.delete(`${this.api}/${this.BatchJob.id}`)
          this.$emit('input', null)
          this.$emit('finished')
          this.LoadingCancelling = false
        } catch (e) {
          console.error(e)
          this.$notify('Could not cancel batch, check the console','error')
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
